'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const StyledSprite = styled__default['default']("svg")(({ theme, strokeColor, fillColor }) => ({
    "--fillColor": fillColor ? theme.colors[theme.colorMode][fillColor] : "",
    "--strokeColor": strokeColor ? theme.colors[theme.colorMode][strokeColor] : "",
    lineHeight: 0,
}));

exports.StyledSprite = StyledSprite;
//# sourceMappingURL=styled.js.map
